import { useEffect } from 'react';

// Service Worker registration for performance optimization
export const ServiceWorkerRegistration = () => {
  useEffect(() => {
    // Only register in production
    if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
      const swUrl = '/sw.js';

      navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
          console.log('SW registered: ', registration);
          
          // Update on reload
          registration.addEventListener('updatefound', () => {
            const installingWorker = registration.installing;
            if (installingWorker) {
              installingWorker.addEventListener('statechange', () => {
                if (installingWorker.state === 'installed') {
                  if (navigator.serviceWorker.controller) {
                    // New content available, show update message
                    console.log('New content is available; please refresh.');
                  }
                }
              });
            }
          });
        })
        .catch((error) => {
          console.log('SW registration failed: ', error);
        });

      // Handle controller changes
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        window.location.reload();
      });
    }
  }, []);

  return null;
};

export default ServiceWorkerRegistration;